import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { APIManagerConfig } from '../apiManager';
import { CreateOrderPayload, ReceiveDataPayload, ReceiveIngredient } from '../../../store/entities/orders/orders.types';
import { generateReportFilename, saveFile } from '../../helpers/utils/utils';
import { IngredientInOrder } from '../../../store/entities/ingredients/ingredients.types';

const OrdersServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => ({
  getOrderList: (): Promise<any> => {
    return HTTPBase.get(`farm/${config.farmId}/stocktransactions?typeCode=1&statuses=1,2`).then((res) => res.data);
  },
  getNextOrderNumber: (payload: { typeCode: number }): Promise<any> => {
    return HTTPBase.post(`farm/${config.farmId}/stocktransactions?nosave=true`, payload).then((res) => res.data);
  },
  createOrder: (payload: CreateOrderPayload, formName: FormName, noSave = false): Promise<any> => {
    return HTTPBase.post(`farm/${config.farmId}/stocktransactions?nosave=${noSave}`, payload, {
      headers: { formName },
    }).then((res) => res.data);
  },
  updateOrder: (payload: CreateOrderPayload, formName: FormName, id): Promise<any> => {
    return HTTPBase.patch(`farm/${config.farmId}/stocktransactions/${id}`, payload, {
      headers: { formName },
    }).then((res) => res.data);
  },
  downloadOrder: (orderId: string, fileName: string): Promise<any> => {
    return HTTPBase.get(`farm/${config.farmId}/reports/purchaseorder/${orderId}/report`, {
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
    }).then((res) => saveFile(res, 'application/pdf', 'pdf', generateReportFilename(fileName)));
  },
  emailOrder: (orderId: string): Promise<any> => {
    return HTTPBase.get(`farm/${config.farmId}/reports/purchaseorder/${orderId}/mail`).then((res) => res.data);
  },
  deleteOrder: (orderId: string): Promise<any> => {
    return HTTPBase.delete(`farm/${config.farmId}/stocktransactions/${orderId}`);
  },
  updateRecord: (
    orderId: string,
    orderItemId: string,
    payload: Partial<IngredientInOrder>,
    ignoreStock: boolean,
    formName: FormName,
  ) => {
    return HTTPBase.patch(
      `farm/${config.farmId}/stocktransactions/${orderId}/items/${orderItemId}?ignorestock=${ignoreStock}`,
      payload,
      {
        headers: { formName },
      },
    ).then((res) => res.data);
  },
  deleteRecord: (orderId: string, orderItemId: string, ignoreStock: boolean) => {
    return HTTPBase.delete(
      `farm/${config.farmId}/stocktransactions/${orderId}/items/${orderItemId}?ignorestock=${ignoreStock}`,
    ).then((res) => res.data);
  },
  receiveIngredient: (
    stockTransactionId: string,
    stockTransactionItemId: string,
    data: ReceiveDataPayload = {},
    formName: FormName,
    noSave = false,
  ): Promise<ReceiveIngredient> => {
    return HTTPBase.patch(
      `/farm/${config.farmId}/stocktransactions/${stockTransactionId}/items/${stockTransactionItemId}?nosave=${noSave}`,
      { ...data, statusCode: 2 },
      { headers: { formName } },
    ).then((res) => res.data);
  },
});

export default OrdersServiceFactory;
